import React from 'react'
import Base from './Base'
import Caousel from './Carousel'
export default function Home() {
  return (
    <Base>
      <Caousel />
    </Base>
  )
}
